import styled from "@emotion/styled";

const SectionWrapper = styled.div`
  background-color: ${(props) => (props.bgColor ? props.bgColor : "#4F8443")};
  padding: ${(props) => (props.p ? props.p : "0")};
  margin: ${(props) => (props.m ? props.m : "0")};
  min-height: 100vh;
  position: relative;
  padding-bottom: ${(props) => (props.pb ? props.pb : "50px")};
  display: flex;
  align-items: center;
  @media screen and (max-width: 900px) {
    min-height: unset;
    min-height: ${(props) => (props.mh900px ? props.mh900px : "")};
  }
  @media screen and (max-width: 650px) {
    min-height: ${(props) => (props.mh ? props.mh : "")};
  }
  @media screen and (max-width: 410px) {
    min-height: ${(props) => (props.mh410 ? props.mh410 : "")};
  }
`;
const P = styled.p`
  font-size: 18px;
  font-family: "two-cent-regular";
  color: ${(props) => (props.color ? props.color : "#ffffff")};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "100%")};
  text-align: ${(props) => (props.align ? props.align : "left")};
  margin-top: ${(props) => (props.mt ? props.mt : "20px")};
  margin-bottom: ${(props) => (props.mb ? props.mb : "20px")};
  margin-left: ${(props) => (props.ml ? props.ml : "0px")};
  margin-right: ${(props) => (props.mr ? props.mr : "0px")};

  @media (max-width: 1250px) {
    font-size: ${(props) => (props.fs1250 ? props.fs1250 : "")};
  }
  @media (max-width: 899px) {
    line-height: 24px;
    max-width: ${(props) => (props.maxWidth899 ? props.maxWidth899 : "100%")};
    margin-left: ${(props) => (props.ml599 ? props.ml599 : "0px")};
  }
  @media (max-width: 1440px) and (max-height: 620px) {
    padding-top: ${(props) => (props.pt630 ? props.pt630 : "0px")};
  }
  @media (max-height: 700px) {
    font-size: 14px;
  }
`;

const SectionHeading = styled.h2`
  color: #ffffff;
  display: inline-block;
  font-size: ${(props) => (props.fs ? props.fs : "200px")};
  font-family: "twocent-bold-italic";
  letter-spacing: 12px;
  margin-top: ${(props) => (props.m ? props.m : "120px")};
  margin-bottom: ${(props) => (props.mb ? props.mb : "40px")};
  @media (max-width: 1440px) {
    font-size: 150px;
    margin-top: 60px;
  }
  @media (max-width: 999px) {
    margin-top: 100px;
    font-size: ${(props) => (props.fs1250 ? props.fs1250 : "")};
  }
  @media (max-width: 750px) {
    letter-spacing: 12px;
    font-size: 100px;
  }
  @media (max-width: 650px) {
    margin-top: 50px;
    letter-spacing: 2px;
    font-size: 70px;
  }
`;
const SectionSubHeading = styled.h3`
  font: 46px "two-cent-regular";
  color: #ffffff;
  margin: ${(props) => (props.m ? props.m : "0px")};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "400px")};
  line-height: 70px;
  /* text-align: ${(props) => (props.align ? props.align : "center")}; */
  letter-spacing: 20px;
  @media (max-width: 899px) {
    font-size: 16px;
  }
  @media (max-width: 599px) {
    max-width: ${(props) => (props.maxWidth599 ? props.maxWidth599 : "400px")};
    line-height: 40px;
    letter-spacing: 10px;
    font-size: 15px;
  }
`;
const SectionSmallHeading = styled.h4`
  padding-top: 0;
  margin-top: ${(props) => (props.mt ? props.mt : "0px")};
  margin-bottom: ${(props) => (props.mb ? props.mb : "10px")};
  font-size: ${(props) => (props.fs ? props.fs : "35px")};
  font-family: "two-cent-Bold";
  color: #ffffff;
  letter-spacing: 4px;
  @media (max-width: 899px) {
    font-size: 30px;
  }
  @media (max-width: 599px) {
    font-size: 25px;
  }
`;
export {
  SectionSmallHeading,
  SectionWrapper,
  P,
  SectionHeading,
  SectionSubHeading,
};
